import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Affiliation } from '../_models/affiliation.model';
import { QueryParamsModel } from '../../_base/crud';

export enum AffiliationActionTypes {
  AllAffiliationsRequested = '[Affiliations Module] All Affiliations Requested',
  AllAffiliationsLoaded = '[Affiliations API] All Affiliations Loaded',
  AffiliationOnServerCreated = '[Edit Affiliation Component] Affiliation On Server Created',
  AffiliationCreated = '[Edit Affiliation Dialog] Affiliation Created',
  AffiliationOnServerUpdated = '[Edit Affiliation Dialog] Affiliation On Server Updated',
  AffiliationUpdated = '[Edit Affiliation Dialog] Affiliation Updated',
  AffiliationStatusOnServerUpdated = '[Affiliations List Page] Affiliation Status On Server Updated Updated',
  AffiliationStatusUpdated = '[Affiliations List Page] Affiliation Status Updated Updated',
  AffiliationsStatusOnServerUpdated = '[Affiliations List Page] Affiliations Status On Server Updated Updated',
  AffiliationsStatusUpdated = '[Affiliations List Page] Affiliations Status Updated Updated',
  AffiliationOnServerDeleted = '[Affiliations List Page] Affiliation On Server Deleted',
  AffiliationDeleted = '[Affiliations List Page] Affiliation Deleted',
  ManyAffiliationsOnServerDeleted = '[Affiliations List Page] Affiliations On Server Deleted',
  ManyAffiliationsDeleted = '[Affiliations List Page] Affiliations Deleted',
  AffiliationsPageRequested = '[Affiliations List Page] Affiliations Page Requested',
  AffiliationsPageLoaded = '[Affiliations API] Affiliations Page Loaded',
  AffiliationsPageCancelled = '[Affiliations API] Affiliations Page Cancelled',
  AffiliationsPageToggleLoading = '[Affiliations] Affiliations Page Toggle Loading',
  AffiliationsActionToggleLoading = '[Affiliations] Affiliations Action Toggle Loading',
  ChangePassword = '[Affiliations] Password changed',
  ActivityPageRequested = '[Affiliations] ActivityPageRequested',
  ThrowError = '[Affiliations] ThrowError',
  ClearErrors = '[Affiliations] ClearErrors',
  AllDescriptionTypesRequested = '[Affiliations] AllDescriptionTypesRequested',
  AllDescriptionTypesLoaded = '[Affiliations] AllDescriptionTypesLoaded',
}

export class AffiliationOnServerCreated implements Action {
  readonly type = AffiliationActionTypes.AffiliationOnServerCreated;
  constructor(public payload: { affiliation: Affiliation }) {}
}

export class AffiliationCreated implements Action {
  readonly type = AffiliationActionTypes.AffiliationCreated;
  constructor(public payload: { affiliation: Affiliation }) {}
}

export class ThrowError implements Action {
  readonly type = AffiliationActionTypes.ThrowError;

  constructor(public payload: { error: any }) {}
}

export class ClearErrors implements Action {
  readonly type = AffiliationActionTypes.ClearErrors;
}
export class AffiliationOnServerUpdated implements Action {
  readonly type = AffiliationActionTypes.AffiliationOnServerUpdated;
  constructor(
    public payload: {
      partialAffiliation: Update<Affiliation>;
      affiliation: Affiliation;
    },
  ) {}
}
export class AffiliationUpdated implements Action {
  readonly type = AffiliationActionTypes.AffiliationUpdated;
  constructor(
    public payload: {
      partialAffiliation: Update<Affiliation>;
      affiliation: Affiliation;
    },
  ) {}
}

export class AffiliationStatusOnServerUpdated implements Action {
  readonly type = AffiliationActionTypes.AffiliationStatusOnServerUpdated;
  constructor(public payload: { id: number; is_active: boolean }) {}
}

export class AffiliationStatusUpdated implements Action {
  readonly type = AffiliationActionTypes.AffiliationStatusUpdated;
  constructor(public payload: { id: number; is_active: boolean }) {}
}

export class AffiliationsStatusOnServerUpdated implements Action {
  readonly type = AffiliationActionTypes.AffiliationsStatusOnServerUpdated;
  constructor(
    public payload: {
      affiliations: Affiliation[];
      is_active: number;
    },
  ) {}
}

export class AffiliationsStatusUpdated implements Action {
  readonly type = AffiliationActionTypes.AffiliationsStatusUpdated;
  constructor(
    public payload: {
      affiliations: Affiliation[];
      is_active: number;
    },
  ) {}
}

export class AffiliationOnServerDeleted implements Action {
  readonly type = AffiliationActionTypes.AffiliationOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class AffiliationDeleted implements Action {
  readonly type = AffiliationActionTypes.AffiliationDeleted;
  constructor(public payload: { id: number }) {}
}

export class ManyAffiliationsOnServerDeleted implements Action {
  readonly type = AffiliationActionTypes.ManyAffiliationsOnServerDeleted;
  constructor(public payload: { ids: any[] }) {}
}

export class ManyAffiliationsDeleted implements Action {
  readonly type = AffiliationActionTypes.ManyAffiliationsDeleted;
  constructor(public payload: { ids: any[] }) {}
}

export class AffiliationsPageRequested implements Action {
  readonly type = AffiliationActionTypes.AffiliationsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class AffiliationsPageLoaded implements Action {
  readonly type = AffiliationActionTypes.AffiliationsPageLoaded;
  constructor(
    public payload: { affiliations: Affiliation[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class AffiliationsPageCancelled implements Action {
  readonly type = AffiliationActionTypes.AffiliationsPageCancelled;
}

export class AffiliationsPageToggleLoading implements Action {
  readonly type = AffiliationActionTypes.AffiliationsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class AffiliationsActionToggleLoading implements Action {
  readonly type = AffiliationActionTypes.AffiliationsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ChangePassword implements Action {
  readonly type = AffiliationActionTypes.ChangePassword;
  constructor(
    public payload: { affiliationName: string; oldPassword: string; newPassword: string },
  ) {}
}

export class AllDescriptionTypesRequested implements Action {
  readonly type = AffiliationActionTypes.AllDescriptionTypesRequested;
}

export type AffiliationActions =
  | AffiliationCreated
  | AffiliationUpdated
  | AffiliationDeleted
  | ManyAffiliationsDeleted
  | AffiliationOnServerCreated
  | AffiliationOnServerUpdated
  | AffiliationOnServerDeleted
  | ManyAffiliationsOnServerDeleted
  | AffiliationStatusOnServerUpdated
  | AffiliationsStatusOnServerUpdated
  | AffiliationsPageLoaded
  | AffiliationsPageCancelled
  | AffiliationsPageToggleLoading
  | AffiliationsPageRequested
  | ChangePassword
  | AffiliationStatusUpdated
  | AffiliationsStatusUpdated
  | ThrowError
  | ClearErrors
  | AllDescriptionTypesRequested
  | AffiliationsActionToggleLoading;
